import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { UserContext } from "context/user";
import { deleteFarm } from "api/Farm";
import CustomModal from "components/Modal";
import InputField from "components/Input";
import Button from "components/Button";
import "./index.scss";

const DeleteFarm = ({ farmInfo, isOpen, redirectUrl, onClose, reload }) => {
  const { token } = useContext(UserContext);
  const history = useHistory();
  const [farmName, setFarmName] = useState("");

  const handleDeleteFarm = async () => {
    try {
      await deleteFarm(farmInfo.farm_id, token);

      toast.success("Farm deleted successfully!");

      setTimeout(() => {
        if (reload) {
          window.location.reload();
        } else {
          history.replace(redirectUrl);
        }
      }, 1000);
    } catch (e) {
      toast.error(e);
    }
  };

  const handleOnClose = () => {
    setFarmName("");
    onClose();
  };

  const handleOnBlur = (name) => {
    setFarmName(name.trim());
  };

  const handleOnKeydown = (e) => {
    if (e.key === "Enter") {
      setFarmName(e.target.value.trim());
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
    >
      <div className="delete-farm" data-testid="delete-modal-content">
        <h3 className="title">Oops!</h3>
        <div className="paragraph">
          Are you sure you want to delete the farm named{" "}
          <span className="bold">{farmInfo?.farm_name}</span> ?<br />
          <p className="warning">
            Deleting this farm also includes its corresponding fields. This
            action is cannot be undone.
          </p>
        </div>

        <InputField
          label="Name of farm"
          value={farmName}
          onChange={(e) => setFarmName(e.target.value)}
          onBlur={(e) => handleOnBlur(e.target.value)}
          onKeydown={(e) => handleOnKeydown(e)}
          placeholder="Please type farm name to confirm"
        />
        <Button
          id="delete-button"
          type="solid"
          color="red"
          label="Delete Farm"
          block
          onClick={handleDeleteFarm}
          disabled={farmInfo?.farm_name.trim() !== farmName}
        />
      </div>
    </CustomModal>
  );
};

DeleteFarm.propTypes = {
  farmInfo: PropTypes.shape({
    farm_id: PropTypes.number.isRequired,
    farm_name: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  redirectUrl: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  reload: PropTypes.bool,
};

DeleteFarm.defaultProps = {
  reload: false,
  redirectUrl: "",
};

export default DeleteFarm;
